//import Vue from 'vue'
import appUtils from '@/plugins/appUtils';

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'activated': 'success',
                'suspended': 'dark',
                //'listed': 'info',
                //'sold': 'danger',
                //'': 'warning',
            }
            return table[status]
        }
    },
    is_public2variant(state) {
        return (is_public) => {
            const table = {
                false: 'dark',
                true: 'warning',
            }
            return table[is_public]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/orders' + (data.uuid ? '/' + data.uuid : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

//        const response = await axios.post('/api/v1/orders' + (data.id ? '/' + data.id : ''), data)
//            .catch(error => error.response || null)
//        return response
    },
    async save_bulk (context, data) {
        const formData = new FormData();
//console.log(appUtils);
        appUtils.appendFormData(formData, data);
        return await axios.post(`/api/v1/orders/bulk`, formData)
            .then((response) => {
                return response;
            })
        .catch((error) => {
console.log(error);
            return Promise.reject(error.response.data.errors || {});
        })
        ;
    },
    async destroy (context, data) {
        const response = await axios.delete('/api/v1/orders/' + data.uuid)
            .catch(error => error.response || null)
        return response
    },
    async cancel (context, data) {
        const response = await axios.post('/api/v1/orders/' + data.uuid + '/cancel')
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        const response = await axios.get('/api/v1/orders' + (typeof data  === 'string' ? '/' + data : ''), {
            params: (typeof data === 'object' ? data : null)
        })
        .catch(error => error.response || null)
        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

